import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import style from '../styles/homepage.module.css';
import {
  FaHome, FaInfoCircle, FaConciergeBell, FaImages,
  FaEnvelope, FaLaptop, FaRecycle, FaPhoneAlt, FaMapMarkerAlt,
  FaArrowRight, FaChevronRight
} from 'react-icons/fa';

const Homepage = () => {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled]   = useState(false);
  const location = useLocation();

  /* Close mobile menu on route change */
  useEffect(() => { setExpanded(false); }, [location]);

  /* Compact on scroll */
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isActive = (path) => location.pathname === path;
  const isServiceActive = isActive('/services') || isActive('/allmetal');

  return (
    <>
      <header className={`${style.siteHeader} ${scrolled ? style.scrolled : ''}`}>

        {/* ── Top info bar ── */}
        <div className={style.topBar}>
          <Container>
            <div className={style.topBarInner}>
              <span className={style.topItem}>
                <FaPhoneAlt className={style.topIcon} />
                <a href="tel:+918762414394">+91 87624 14394</a>
                <span className={style.separator}>|</span>
                <a href="tel:+919972474042">+91 99724 74042</a>
              </span>
              <span className={style.topItem}>
                <FaEnvelope className={style.topIcon} />
                <a href="mailto:kmkindustries22@gmail.com">kmkindustries22@gmail.com</a>
              </span>
              <span className={style.topItem}>
                <FaMapMarkerAlt className={style.topIcon} />
                <span>Bilwaradahalli, Shanubhoganahalli, Bangalore – 560083</span>
              </span>
            </div>
          </Container>
        </div>

        {/* ── Main navbar ── */}
        <div className={style.navWrapper}>
          <Container>
            <Navbar
              expand="lg"
              expanded={expanded}
              onToggle={(val) => setExpanded(val)}
              className={style.navbar}
            >
              {/* Logo */}
              <Navbar.Brand as={Link} to="/" className={style.brand}>
                <img src="/logo1.png" height="80" width="144" alt="KMK Industries" />
              </Navbar.Brand>

              {/* Hamburger */}
              <Navbar.Toggle aria-controls="main-nav" className={style.toggler} />

              <Navbar.Collapse id="main-nav">
                <Nav className="ms-auto" as="ul">

                  <Nav.Item as="li">
                    <Nav.Link
                      as={Link} to="/"
                      className={`${style.navLink} ${isActive('/') ? style.active : ''}`}
                    >
                      <FaHome className={style.navIcon} />
                      Home
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item as="li">
                    <Nav.Link
                      as={Link} to="/about"
                      className={`${style.navLink} ${isActive('/about') ? style.active : ''}`}
                    >
                      <FaInfoCircle className={style.navIcon} />
                      About
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item as="li">
                    <NavDropdown
                      title={
                        <span className={style.dropdownTitle}>
                          <FaConciergeBell className={style.navIcon} />
                          Services
                        </span>
                      }
                      id="services-dropdown"
                      className={`${style.navLink} ${style.dropdown} ${isServiceActive ? style.active : ''}`}
                    >
                      {/* IT Assets */}
                      <NavDropdown.Item
                        as={Link} to="/services"
                        className={style.dropdownItem}
                      >
                        <span className={style.dropdownIcon}><FaLaptop /></span>
                        <div className={style.dropdownItemText}>
                          <span className={style.dropdownItemLabel}>IT Assets Disposition</span>
                          <span className={style.dropdownItemSub}>Secure data destruction & recovery</span>
                        </div>
                        <FaChevronRight className={style.dropdownArrow} />
                      </NavDropdown.Item>

                      {/* All Metal */}
                      <NavDropdown.Item
                        as={Link} to="/allmetal"
                        className={style.dropdownItem}
                      >
                        <span className={style.dropdownIcon}><FaRecycle /></span>
                        <div className={style.dropdownItemText}>
                          <span className={style.dropdownItemLabel}>All Metal Disposition</span>
                          <span className={style.dropdownItemSub}>Ferrous & non-ferrous recycling</span>
                        </div>
                        <FaChevronRight className={style.dropdownArrow} />
                      </NavDropdown.Item>
                    </NavDropdown>
                  </Nav.Item>

                  <Nav.Item as="li">
                    <Nav.Link
                      as={Link} to="/galary"
                      className={`${style.navLink} ${isActive('/galary') ? style.active : ''}`}
                    >
                      <FaImages className={style.navIcon} />
                      Gallery
                    </Nav.Link>
                  </Nav.Item>

                </Nav>

                {/* CTA */}
                <Link to="/contact" className={style.ctaBtn}>
                  Contact Us <FaArrowRight />
                </Link>
              </Navbar.Collapse>
            </Navbar>
          </Container>
        </div>

      </header>

      {/* Spacer keeps layout stable */}
      <div
        className={`${style.headerSpacer} ${scrolled ? style.spacerShort : ''}`}
        aria-hidden="true"
      />
    </>
  );
};

export default Homepage;
